export const themeColors = {
  primary: {
    bg: 'bg-[#004AAD]', // Azul Lytiks
    bgHover: 'hover:bg-[#003B8A]',
    text: 'text-[#004AAD]',
    border: 'border-[#004AAD]',
    ring: 'focus:ring-[#004AAD]',
  },
  secondary: {
    bg: 'bg-sky-500',
    bgHover: 'hover:bg-sky-600',
    text: 'text-sky-600',
  },
  accent: {
    bg: 'bg-amber-400',
    text: 'text-amber-500',
  },
};
